// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0a391fd3","455":"7b214e2e","977":"f6f286c3"}[chunkId] + ".chunk.js";
};